import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(function() {
  
  if ($('#controller-domains').length === 0) { return; }
  
  if ($('#new_domain').length > 0) {
    
    $('#new_domain').find('input[type=text], input[type=email], input[type=password]').focus(function() {
      $(this).parent().removeClass('field_with_errors');
      if ($(this).hasClass('domain-field')) {
        $(this).data('placeholder', $(this).attr('placeholder'));
        $(this).attr('placeholder', '');
        if ($(this).val() === '') { return $(this).val('www.'); }
      } else {
        $(this).data('placeholder', $(this).attr('placeholder'));
        return $(this).attr('placeholder', '');
      }
    });
    $('#new_domain').find('input[type=text], input[type=email], input[type=password]').blur(function() {
      if ($(this).hasClass('domain-field')) {
        $(this).attr('placeholder', $(this).data('placeholder'));
        if ($(this).val() === 'www.') { return $(this).val(''); }
      } else {
        return $(this).attr('placeholder', $(this).data('placeholder'));
      }
    });
    
    const domain_field = $('#new_domain').find('input[type=text].domain-field');
    if ((domain_field.val() !== '') && (domain_field.val().indexOf('www.') === -1)) { return domain_field.val(`www.${domain_field.val()}`); }
  }
});
  